export default __webpack_public_path__ + "static/media/starters.32dc679d.png";